export interface ComponentCommonProps {
  event?: any
  className?: string
  id?: string
  key?: string
}

export type ContainerProps = {
  containerMode?: Mode
  spaceY?: SpaceY
  spaceTop?: SpaceTop
  spaceBottom?: SpaceBottom
}

export type Mode = 'section' | 'fragment'

export type SpaceY = 'default' | 'none' | string
export type SpaceTop = 'default' | 'none' | string
export type SpaceBottom = 'default' | 'none' | string

export type Img = {
  url: string
  alt?: string
}

export type Video = {
  url: string
}

export type Theme = 'light' | 'dark'
export type Shape = 'rounded' | 'square'
export type Align = 'left' | 'center' | 'right'

export type Media = {
  alt: string
  url: string
  thumbnailURL: string
  mimeType?: 'video/mp4' | 'image/jpeg' | 'image/png' | 'image/webp' | 'image/svg+xml'
  width?: number
  height?: number
  focalX?: number
  focalY?: number
}

export type GSAPContext = {
  gsap?: any
  ScrollTrigger?: any
  SplitText?: any
}

export type CurrencyDisplayType = Intl.NumberFormatOptions['currencyDisplay']
